import React from 'react';
import { ViewerPropertiesComplete } from '../model';
export const MediaAudio: React.FC<ViewerPropertiesComplete> = ({ src, autoPlay, muted }) => {
  return (
    <audio
      className="gen-file-viewer__audio"
      src={src}
      crossOrigin="use-credentials"
      controls
      muted={muted}
      autoPlay={autoPlay}
      onLoadedMetadata={({ target }) => {
        // eslint-disable-next-line no-console
        console.warn(target);
      }}
    />
  );
};
